import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (href && href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (onClick) {
      onClick();
    }
  };
  const baseClasses = 'inline-block w-full md:w-auto text-center bg-[#c4f000] hover:bg-[#d4ff1a] text-[#1f2e10] font-bold text-sm md:text-base py-3 px-6 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 active:scale-95';
  if (href) {
    return <a href={href} onClick={handleClick} className={`${baseClasses} ${className}`} data-id="element-42">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={`${baseClasses} ${className}`} data-id="element-43">
      {children}
    </button>;
}